export class EmployeeSchoolData {
    FirstName: string;
    LastName: string;

    constructor() {
        this.FirstName = '';
        this.LastName = '';
    }
}



// WEBPACK FOOTER //
// ./src/app/main/models/employee/employee-school-data.ts